import { useEffect } from "react";

const revealGroups = [
  ".stat-band > p, .stats-grid article",
  ".opening-statement > *",
  ".section-heading > *, .capability-card",
  ".plate-service-intro > *, .plate-metrics article, .plate-card",
  ".plate-import-section > *",
  ".press-intro > *, .press-card",
  ".industries-heading > *, .industry-card",
  ".printer-callout > *",
  ".delivery-section > *",
  ".workflow-copy, .workflow-list li",
  ".employee-gateway > *",
  ".contact-section > *",
  ".site-footer > *",
];

export default function MotionEnhancer() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const revealItems = [];

    revealGroups.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element, index) => {
        if (element.dataset.revealReady) return;
        element.dataset.revealReady = "true";
        element.classList.add("scroll-reveal");
        element.style.setProperty("--reveal-delay", `${Math.min(index, 5) * 70}ms`);
        revealItems.push(element);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -7% 0px", threshold: 0.1 },
    );

    revealItems.forEach((element) => observer.observe(element));
    document.documentElement.classList.add("motion-ready");

    let ticking = false;
    const updateProgress = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? Math.min(window.scrollY / scrollable, 1) : 0;
      document.documentElement.style.setProperty("--page-progress", String(progress));
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    };

    updateProgress();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
      document.documentElement.classList.remove("motion-ready");
      document.documentElement.style.removeProperty("--page-progress");
    };
  }, []);

  return <div className="page-progress" aria-hidden="true"><span /></div>;
}
